import React from 'react'
import axios from 'axios'
import {Link} from "react-router-dom";

class MenuBar extends React.Component {	  
	
	render() {				
		return (
			<div id="buttons">
				<label style={{width: '138px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Payday">Profile</Link></label>							
				<label style={{width: '138px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Paybank">Bank</Link></label>
				<label style={{width: '138px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Reloan">Reloan</Link></label>														
				<label style={{width: '138px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Setting">Settings</Link></label>
				<label style={{width: '138px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Member">Logout</Link></label>				
			</div>
		)
	}	
}


export default MenuBar